import axios from "axios";
const liff = window.liff;
let isInit = false;
let profile = {};
let liffInfo = {};

class liffHelper {
  init() {
    return new Promise((resolve, reject) => {
      (async () => {
        // if (!isInit) {
          var liffData = await liff
            .init({ liffId: `1653921718-oeQ08PKd` })
            .catch((err) => {
              console.log("Fail to init LIFF, please run inside LINE only");
              reject();
            });
          // liff.init(
          //   (data) => {
            // alert(JSON.stringify(liffData));
          liffInfo = liff.getContext();
          isInit = true;
          //     // alert(data.context.groupId)
          resolve(liffInfo);
          //   },
          //   (err) => {
          //     console.log("Fail to init LIFF, please run inside LINE only");
          //     reject();
          //   }
          // );
        // } else {
        //   // alert(JSON.stringify(liffInfo));
        //   resolve();
        // }
      })();
    });
  }

  initcontext() {
    return new Promise((resolve, reject) => {
      if (!isInit) {
        liff.init(
          (data) => {
            liffInfo = data;
            isInit = true;
            // alert(data.context.groupId)
            resolve(data.context);
          },
          (err) => {
            console.log("Fail to init LIFF, please run inside LINE only");
            reject();
          }
        );
      } else {
        resolve();
      }
    });
  }

  getLIFFInfo() {
    return liffInfo;
  }

  getProfile() {
    return new Promise((resolve, reject) => {
      this.init()
        .then(() => {

         const lise = liff.getContext();
         alert(lise.profile)
          // if (isInit && !profile.userId) {
          //   liff
          //     .getProfile()
          //     .then((pf) => {
          //       profile = pf;
          //       resolve(profile);
          //     })
          //     .catch((err) => {
          //       console.log("get profile error", err);
          //       reject(err);
          //     });
          // } else {
          //   resolve(profile);
          // }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  getProfile2() {
    return new Promise((resolve, reject) => {
      this.init()
        .then(() => {
          // if (isInit && !profile.userId) {
          //   liff
          //     .getProfile()
          //     .then((pf) => {
          //       profile = pf;
          //       resolve(profile);
          //     })
          //     .catch((err) => {
          //       console.log("get profile error", err);
          //       reject(err);
          //     });
          // } else {
          //   resolve(profile);
          // }
          const lise = liff.getContext();
          alert(JSON.stringify(lise))
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  closeWindow() {
    liff.closeWindow();
  }

  openWindow(url, external) {
    liff.openWindow({ url, external });
  }

  sendMessages(messages) {
    const messagesToSend = Array.isArray(messages) ? messages : [messages];
    return new Promise((resolve, reject) => {
      this.init()
        .then(() => {
          liff
            .sendMessages(messagesToSend)
            .then(() => {
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  checkmongo = (Liffid, collec) => {
    let jsondata = {
      database: "CI_Docker_MessengerInstance",
      table: collec,
      query: { key: "Liff_Id", query: Liffid },
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "finder",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data[0];
          // console.log(arrf)
          // alert(arrf)
          // this.setState({
          //   mongo: {
          //     ...this.state.mongo,
          //     Ck_Name: 'kuy',
          //   }
          // })
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };
  //-----------------------------รอแก้-------------------------------
  list = (limit, collec) => {
    let jsondata = {
      database: "CI_Docker_MessengerInstance",
      table: collec,
      query: {},
      limit: limit,
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "findlimit",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };
  //-----------------------------รอแก้-------------------------------
  listline = (limit) => {
    var jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Brance",
      query: {},
      type: "",
      limit: limit,
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            path: "findlimit",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;

          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          alert(error);
          reject();
        });
    });
  };
  //-----------------------------รอแก้-------------------------------
  listlineout = (limit) => {
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "out_brance",
      query: {},
      type: "",
      limit: limit,
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "findlimit",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  listlinefam = (limit, param) => {
    let jsondata = {
      database: "CI_Docker_FAM",
      table: param,
      query: {},
      type: "",
      limit: limit,
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "findlimit",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  mongget = (name) => {
    let jsondata = {
      database: "CI_Docker_MessengerInstance",
      table: "MsnRafco_Sender",
      query: { MsnName: name },
      type: "",
      limit: 1,
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "findlimit2",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  getgroup = (groupId) => {
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Admin_LIne",
      query: { key: "group_id", query: groupId },
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "finder",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data[0];
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };
  getgrouppgh = (groupId) => {
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Group_PGH",
      query: { key: "group_id", query: groupId },
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "finder",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data[0];
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  getgroupfam = (groupId, param) => {
    let jsondata = {
      database: "CI_Docker_FAM",
      table: param,
      query: { key: "group_id", query: groupId },
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "finder",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data[0];
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  chkad = (groupId) => {
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Admin_Regis",
      query: { key: "line_id", query: groupId },
    };
    return new Promise((resolve, reject) => {
      // alert('asdfasdf')
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "finder",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data[0];
          // alert("++++++"+arrf)
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  checkin = (picurl) => {
    return new Promise((resolve, reject) => {
      axios
        .get(picurl)
        .then(function (response) {
          // alert(response.status)
          // const arrf = response.data
          // alert(picurl)
          resolve(picurl);
        })
        .catch(function (error) {
          // alert(error.status)
          // alert('errpic')
          // alert(picurl)
          // console.log(error);
          // alert('https://linebotkeep-file.s3-ap-southeast-1.amazonaws.com/QR/4-512.png')
          resolve(picurl);
          // reject()
        });
    });
  };

  insertadmin = (
    Liffid,
    Liff_Name,
    Liff_Pic,
    Ck_NameF,
    Ck_NameL,
    Ck_Brance,
    idfb,
    collec
  ) => {
    let jsondata = {
      database: "CI_Docker_MessengerInstance",
      table: collec,
      insert: {
        Liff_Id: Liffid,
        Liff_Name: Liff_Name,
        Liff_Pic: Liff_Pic,
        Ck_NameF: Ck_NameF,
        Ck_NameL: Ck_NameL,
        Ck_Brance: Ck_Brance,
        idfb: idfb,
      },
    };
    // alert(Liffid,Liff_Name,Liff_Pic,Ck_NameF,Ck_NameL,Ck_Brance)
    // alert(Liff_Name)
    // alert(Liff_Pic)
    // alert(Ck_NameF)
    // alert(Ck_NameL)
    // alert(Ck_Brance)

    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "inserter",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  insertlinegroupfam = (
    displayName,
    groupId,
    Ck_NameF,
    LinkG,
    selected,
    param
  ) => {
    let jsondata = {
      database: "CI_Docker_FAM",
      table: param,
      insert: {
        group_id: groupId,
        save_at: displayName,
        group_name: Ck_NameF,
        LinkG: LinkG,
        brance: selected,
        employee_id: "NULL",
        datestamp: "",
      },
    };
    return new Promise((resolve, reject) => {
      if (groupId == undefined || groupId == "") {
        // inss.sta == "AddSuccess" || inss.sta == "Success!"
        resolve({ sta: "Noap" });
      }

      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "insertsocialpgh",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  insertlinegroup = (displayName, groupId, Ck_NameF, LinkG, selected) => {
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Admin_LIne",
      insert: {
        group_id: groupId,
        save_at: displayName,
        group_name: Ck_NameF,
        LinkG: LinkG,
        brance: selected,
        employee_id: "NULL",
        datestamp: "",
      },
    };
    return new Promise((resolve, reject) => {
      if (groupId == undefined || groupId == "") {
        // inss.sta == "AddSuccess" || inss.sta == "Success!"
        resolve({ sta: "Noap" });
      }

      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "insertsocialpgh",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  insertlinegroupaam = (
    displayName,
    groupId,
    Ck_NameF,
    LinkG,
    selected,
    grouptype
  ) => {
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Admin_LIne",
      insert: {
        group_id: groupId,
        save_at: displayName,
        group_name: Ck_NameF,
        LinkG: LinkG,
        brance: selected,
        employee_id: "NULL",
        datestamp: "",
        grouptype: grouptype,
      },
    };
    return new Promise((resolve, reject) => {
      if (groupId == undefined || groupId == "") {
        // inss.sta == "AddSuccess" || inss.sta == "Success!"
        resolve({ sta: "Noap" });
      }

      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "insertsocialaam",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };

  insertlinegroupphg = (
    displayName,
    groupId,
    Ck_NameF,
    LinkG,
    selected,
    CusIDem
  ) => {
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Group_PGH",
      insert: {
        group_id: groupId,
        save_at: displayName,
        group_name: Ck_NameF,
        LinkG: LinkG,
        brance: selected,
        employee_id: CusIDem,
        datestamp: "",
      },
    };
    return new Promise((resolve, reject) => {
      // axios
      //   .post(
      //     "https://vsiz37j2ea.execute-api.ap-southeast-1.amazonaws.com/latest/insertsocialpgh",
      //     jsondata,
      //     { headers: { Accept: "application/json" } }
      //   )
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            path: "insertsocialpgh",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };
  insertlineadmin = (displayName, groupId, CusIDem) => {
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Admin_Regis",
      insert: {
        line_id: groupId,
        displayName: displayName,
        employee_id: CusIDem,
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "adminsocial",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };
  updategroup = (displayName, groupId, Ck_NameF, LinkG, selected) => {
    //alert(displayName)
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Admin_LIne",
      query: { key: "group_id", query: groupId },

      // datestamp: ''
      newvalues: [
        { key: "save_at", newvalues: displayName },
        { key: "group_name", newvalues: Ck_NameF },
        { key: "LinkG", newvalues: LinkG },
        { key: "brance", newvalues: selected },
        { key: "employee_id", newvalues: "NULL" },
        { key: "datestamp", newvalues: "" },
      ],
    };
    return new Promise((resolve, reject) => {
      // axios
      //   .post(
      //     "https://vsiz37j2ea.execute-api.ap-southeast-1.amazonaws.com/latest/update",
      //     jsondata,
      //     { headers: { Accept: "application/json" } }
      //   )
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "updatesocialpgh",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          alert(error);
          console.log(error);
          reject();
        });
    });
  };

  updategroupaamG = (
    displayName,
    groupId,
    Ck_NameF,
    LinkG,
    selected,
    typeG
  ) => {
    //alert(displayName)
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Admin_LIne",
      query: { key: "group_id", query: groupId },

      // datestamp: ''
      newvalues: [
        { key: "save_at", newvalues: displayName },
        { key: "group_name", newvalues: Ck_NameF },
        { key: "LinkG", newvalues: LinkG },
        { key: "brance", newvalues: selected },
        { key: "employee_id", newvalues: "NULL" },
        { key: "datestamp", newvalues: "" },
        { key: "grouptype", newvalues: typeG },
      ],
    };
    return new Promise((resolve, reject) => {
      // axios
      //   .post(
      //     "https://vsiz37j2ea.execute-api.ap-southeast-1.amazonaws.com/latest/update",
      //     jsondata,
      //     { headers: { Accept: "application/json" } }
      //   )
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "updatesocialaamG",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          alert(error);
          console.log(error);
          reject();
        });
    });
  };

  updategroupfam = (
    displayName,
    groupId,
    Ck_NameF,
    LinkG,
    selected,
    CusIDem,
    param
  ) => {
    let jsondata = {
      database: "updategroup",
      table: param,
      query: { key: "group_id", query: groupId },
      newvalues: [
        { key: "save_at", newvalues: displayName },
        { key: "group_name", newvalues: Ck_NameF },
        { key: "LinkG", newvalues: LinkG },
        { key: "brance", newvalues: selected },
        { key: "employee_id", newvalues: CusIDem },
        { key: "datestamp", newvalues: "" },
      ],
    };
    return new Promise((resolve, reject) => {
      // axios
      //   .post(
      //     "https://vsiz37j2ea.execute-api.ap-southeast-1.amazonaws.com/latest/updatesocialpgh",
      //     jsondata,
      //     { headers: { Accept: "application/json" } }
      //   )
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "updatesocialpgh",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          alert(error);
          console.log(error);
          reject();
        });
    });
  };

  updategrouppgh = (
    displayName,
    groupId,
    Ck_NameF,
    LinkG,
    selected,
    CusIDem
  ) => {
    let jsondata = {
      database: "CI_Docker_Social_Line",
      table: "Group_PGH",
      query: { key: "group_id", query: groupId },
      newvalues: [
        { key: "save_at", newvalues: displayName },
        { key: "group_name", newvalues: Ck_NameF },
        { key: "LinkG", newvalues: LinkG },
        { key: "brance", newvalues: selected },
        { key: "employee_id", newvalues: CusIDem },
        { key: "datestamp", newvalues: "" },
      ],
    };
    return new Promise((resolve, reject) => {
      // axios
      //   .post(
      //     "https://vsiz37j2ea.execute-api.ap-southeast-1.amazonaws.com/latest/updatesocialpgh",
      //     jsondata,
      //     { headers: { Accept: "application/json" } }
      //   )
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "updatesocialpgh",
            port: "5003",
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          alert(error);
          console.log(error);
          reject();
        });
    });
  };
  creatG = (
    namecus,
    Ck_NameF,
    Ck_NameL,
    selected,
    Fistname,
    Lastname,
    Card,
    phone,
    bracecus,
    GroupName,
    Ck_Brance,
    idfb,
    table
  ) => {
    let jsondata = {
      namecus: namecus,
      Ck_NameF: Ck_NameF,
      Ck_NameL: Ck_NameL,
      picture: selected,
      Fistname: Fistname,
      Lastname: Lastname,
      Card: Card,
      phone: phone,
      bracecus: bracecus,
      GroupName: GroupName,
      Ck_Brance: Ck_Brance,
      idfb: idfb,
      rout: "creatgroupfb",
      collectq: table,
    };

    // alert(Liff_Name)
    // alert(Liff_Pic)
    // alert(Ck_NameF)
    // alert(Ck_NameL)
    // alert(Ck_Brance)

    return new Promise((resolve, reject) => {
      // axios.post('https://314df321.ngrok.io/creatgroupfb', jsondata, { headers: { 'Accept': 'application/json' } })
      // axios
      //   .post(
      //     "https://7j966v03m9.execute-api.ap-southeast-1.amazonaws.com/latest/apimsg",
      //     jsondata,
      //     { headers: { Accept: "application/json" } }
      //   )
      var port = "";

      if (table == "MsnRPLC_Sender") {
        port = "5019";
      }
      if (table == "MsnRafco_Sender") {
        port = "5030";
      }
      // if (table == 'MsnRafco_Sender') { port = '5007' }
      if (table == "MsnAIC_Sender") {
        port = "5032";
      }
      // alert(port)
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "creatgroupfb",
            port: port,
          },
        })
        .then(function (response) {
          // const arrf = response.data
          // alert(arrf)
          // alert('suss')
          resolve(response.data);
        })
        .catch(function (error) {
          // alert('error')
          reject(error);
        });
    });
  };

  getidfb = (namefb, port) => {
    let jsondata = {
      namefb: namefb,
      rout: "getidfb",
    };
    return new Promise((resolve, reject) => {
      // axios.post('https://e69485f1.ngrok.io/', jsondata, { headers: { 'Accept': 'application/json' } })
      //   .then(function (response) {
      //     const arrf = response.data
      //     // alert(arrf)
      //     resolve(arrf)
      //   })
      // axios
      //   .post(
      //     "https://7j966v03m9.execute-api.ap-southeast-1.amazonaws.com/latest/apimsg",
      //     jsondata,
      //     { headers: { Accept: "application/json" } }
      //   )
      axios
        .post("/api", jsondata, {
          headers: {
            Accept: "application/json",
            authorization:
              "Basic YWdzLWNpOmNkV21XLG81SGxOUGR9Z3pFWmxrYnpDSih6RHRQKQ==",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            path: "getidfb",
            port: port,
          },
        })
        .then(function (response) {
          const arrf = response.data;
          // alert(arrf)
          resolve(arrf);
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  };
}
export default new liffHelper();



// WEBPACK FOOTER //
// src/utils/liffHelper.js